export default __webpack_public_path__ + "static/media/main-bg-section1.5f23370c.png";